import { render, staticRenderFns } from "./DialgoNoOkHpH.vue?vue&type=template&id=28cfeab1&scoped=true&"
import script from "./DialgoNoOkHpH.vue?vue&type=script&lang=js&"
export * from "./DialgoNoOkHpH.vue?vue&type=script&lang=js&"
import style0 from "./DialgoNoOkHpH.vue?vue&type=style&index=0&id=28cfeab1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cfeab1",
  null
  
)

export default component.exports